import { render, staticRenderFns } from "./vWidget.vue?vue&type=template&id=2142ea48&scoped=true&"
import script from "./vWidget.vue?vue&type=script&lang=js&"
export * from "./vWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2142ea48",
  null
  
)

export default component.exports